import moment from "moment";
import { ChangePassword } from "../../../models/changePswd";
import { UsersFilter } from "../../../models/filters/usersFilter";
import { NewPass } from "../../../models/newPass";
import { ResponseData } from "../../../models/responseData";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { EntUser } from "../../../models/user";
import { agroApi } from "../api";
import { Paths } from "../../../paths";


export class ResGetUser extends ResponseData {
  result: EntUser|null = null;
}

export class ResGetUsersList extends ResponseData {
  result: EntUser[] = [];
}

export const usersApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getUserList: builder.query<ResponseDataGet<EntUser>, UsersFilter>({
	  query: (filter) => ({
		url: `${ Paths.users }/get-all`,
		method: "POST",
		body: JSON.stringify(filter)
	  }),
	}),
	getUserById: builder.query<ResponseDataTest<EntUser>, number>({
	  query: (id) => ({
		url: `${ Paths.users }/${ id }`,
		method: 'GET'
	  })
	}),
	addUser: builder.mutation<ResponseDataTest<EntUser>, EntUser>({
	  query: (body) => ({
		url: `${ Paths.users }`,
		method: "POST",
		body: JSON.stringify(body, (key, value) => {
		  if (typeof value === 'string' && /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/.test(value)) {
			return moment(value).toISOString()
		  }
		  return value;
		})
	  }),
	}),
	changePassworUser: builder.mutation<ResponseDataTest<NewPass>, NewPass>({
	  query: (body) => ({
		url: `${ Paths.users }/admin/change-password`,
		method: "POST",
		body: JSON.stringify(body)
	  }),
	}),
	editUser: builder.mutation<ResponseDataTest<EntUser>, EntUser>({
	  query: (body,) => ({
		url: `${ Paths.users }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),
	deleteUser: builder.mutation<ResponseDataTest<EntUser>, number>({
	  query: (id) => ({
		url: `${ Paths.users }/${ id }`,
		method: 'DELETE',
	  }),
	}),
	changeMyPassword: builder.mutation<ResGetUser, ChangePassword>({
	  query: (body) => ({
		url: `${ Paths.users }/change-password`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	})
  }),
  overrideExisting: false,
});

export const {
  useAddUserMutation,
  useEditUserMutation,
  useDeleteUserMutation,
  useChangeMyPasswordMutation,
  useChangePassworUserMutation,
  useLazyGetUserListQuery
} = usersApi;
